import React from 'react';

const IconCurvedArrowLeft = ({ size = 36, onClick }) => {
    return (
        <div
            className="icon-arrow-left"
            style={{ fontSize: size }}
            onClick={onClick} // Add onClick handler
        >
            <svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 25 25" style={{ height:"25px"}}>
                <path style={{fill:"white"}} d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z" data-name="Left"/>
            </svg>
        </div>
    );
};

export default IconCurvedArrowLeft;
